const MPurchaseOfficer = [
  {
    title: 'Dashboard',
    is_heading: false,
    is_active: false,
    link: {
      name: 'po.dashboard'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-objects-column',
    active_icon: 'fad fa-objects-column'
  }
]

const MROPurchaseOrders = [
  {
    title: 'Purchase Orders',
    is_heading: true,
    is_active: false,
    link: {
      name: 'po.purchase-orders'
    },
    class_name: 'mt-3 font-weight-bolder'
  },
  {
    title: 'Requests',
    is_heading: false,
    is_active: false,
    link: {
      name: 'po.purchase-orders.requests'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-plus',
    active_icon: 'fad fa-cart-circle-plus'
  },
  {
    title: 'Receiving',
    is_heading: false,
    is_active: false,
    link: {
      name: 'po.purchase-orders.receiving'
    },
    class_name: '',
    is_icon_class: true,
    icon: 'fat fa-cart-circle-arrow-down',
    active_icon: 'fad fa-cart-circle-arrow-down'
  }
]

const MROInterBranches = [
  // {
  //   title: 'Inter Branches',
  //   is_heading: true,
  //   is_active: false,
  //   link: {
  //     name: 'po.inter-branches'
  //   },
  //   class_name: 'mt-3 font-weight-bolder'
  // },
  // {
  //   title: 'Transfers',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'po.inter-branches.transfers'
  //   },
  //   class_name: '',
  //   is_icon_class: true,
  //   icon: 'fat fa-cart-circle-arrow-up',
  //   active_icon: 'fad fa-cart-circle-arrow-up'
  // },
  // {
  //   title: 'Posting',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'po.inter-branches.posting'
  //   },
  //   class_name: '',
  //   is_icon_class: true,
  //   icon: 'fat fa-code-compare',
  //   active_icon: 'fad fa-code-compare'
  // },
  // {
  //   title: 'Receiving',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'po.inter-branches.receiving'
  //   },
  //   class_name: '',
  //   is_icon_class: true,
  //   icon: 'fat fa-cart-circle-arrow-down',
  //   active_icon: 'fad fa-cart-circle-arrow-down'
  // }
]

const MROInterWarehouses = [
  // {
  //   title: 'Inter Warehouses',
  //   is_heading: true,
  //   is_active: false,
  //   link: {
  //     name: 'po.inter-warehouses'
  //   },
  //   class_name: 'mt-3 font-weight-bolder'
  // },
  // {
  //   title: 'Transfers',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'po.inter-warehouses.transfers'
  //   },
  //   class_name: '',
  //   is_icon_class: true,
  //   icon: 'fat fa-cart-circle-arrow-up',
  //   active_icon: 'fad fa-cart-circle-arrow-up'
  // },
  // {
  //   title: 'Posting',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'po.inter-warehouses.posting'
  //   },
  //   class_name: '',
  //   is_icon_class: true,
  //   icon: 'fat fa-code-compare',
  //   active_icon: 'fad fa-code-compare'
  // },
  // {
  //   title: 'Receiving',
  //   is_heading: false,
  //   is_active: false,
  //   link: {
  //     name: 'po.inter-warehouses.receiving'
  //   },
  //   class_name: '',
  //   is_icon_class: true,
  //   icon: 'fat fa-cart-circle-arrow-down',
  //   active_icon: 'fad fa-cart-circle-arrow-down'
  // }
]

export default MPurchaseOfficer.concat(
  MROPurchaseOrders,
  MROInterBranches,
  MROInterWarehouses
)
